import { getToken, isTokenExpired } from '@/utils/request'
import { getUser } from '@/utils/auth'

/**
 * 判断当前用户是否已登录（token 有效 + 本地用户数据存在）
 */
export function isLoggedIn() {
  const token = getToken()
  if (!token || isTokenExpired()) return false
  return !!getUser()
}

/**
 * 在 Vue 组件中校验登录状态；未登录则弹提示并跳转登录页。
 *
 * @param {Vue} vm - Vue 实例（需含 $router / $route / $message）
 * @param {string} [tip='请先登录后使用该功能'] - 未登录弹出的警告文案
 * @returns {boolean} true = 已登录，false = 未登录（已触发跳转）
 */
export function requireLogin(vm, tip) {
  if (isLoggedIn()) return true
  const message = tip || '请先登录后使用该功能'
  if (vm && vm.$message) vm.$message.warning(message)
  const redirect = (vm && vm.$route) ? vm.$route.fullPath : window.location.pathname
  if (vm && vm.$router) {
    vm.$router.push({ name: 'Login', query: { redirect } }).catch(() => {})
  }
  return false
}
